import { PPCPositionTypesByMarket } from '../enums/PPCEnums';

export type ProductPlacementCopy = {
  productId: number;
  mainWebShopId: number;
  fictionalShopId: number;
  market: string;
  colours: Array<ProductPlacementCopyColor>;
  links?: Array<string>;
};

export type ProductPlacementCopyColor = {
  colourId: number;
  positions: Array<ProductPlacementCopyColorPosition>;
};

export type ProductPlacementCopyColorPosition = {
  active: boolean;
  sortOrder: number;
  highlight: boolean;
  allShops: boolean;
  placementPositionId: PPCPositionTypesByMarket;
  overlayPosition: string;
  startDate: number;
  endDate?: number;
  languageId: number;
  languageCode: string;
  name: string;
  text: string;
};
